/**
 * Le cadrage de l'image de fond d'une séquence vidéo (`seg.crop`) : le même recadrage que
 * les ImageFrame de la lib (`cropX`/`cropY`/`scale`, lib/crop.ts), plus la taille native
 * de l'image sur laquelle il a été fait — Remotion (creatorstudio, segmentCrop.js) rejoue
 * `photoRect` avec, sans avoir à mesurer l'image.
 */
import type { Crop, ImageFrame } from "@frabr/fabric-editor";

export interface SegmentCrop extends Crop {
  naturalWidth: number
  naturalHeight: number
}

interface CroppedSegment {
  crop?: SegmentCrop
}

/** Le cadrage d'un segment, dans le dialecte des calques image (pour un ImageFrame). */
export function segmentCropOf(seg: CroppedSegment | null | undefined): { cropX: number; cropY: number; scale: number } {
  const crop = seg?.crop;
  return crop ? { cropX: crop.x, cropY: crop.y, scale: crop.scale } : { cropX: 0.5, cropY: 0.5, scale: 1 };
}

/** Le cadrage d'un ImageFrame, tel que le segment le garde. */
export function cropFromFrame(frame: ImageFrame): SegmentCrop {
  const { x, y, scale } = frame.crop;
  const { w, h } = frame.naturalSize;
  return { x, y, scale, naturalWidth: w, naturalHeight: h };
}
